export const CONTACT = {
  email: "hello@thepeoplesjosh.com",
  phone: "+91-6398997143",
  phoneHref: "+916398997143",
};

export const LOGO_MARK =
  "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/vn9cn7sq_ChatGPT_Image_Jul_29__2026__09_28_22_PM-removebg-preview.png";

export const PDF_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/q85sxquj_%5BFlip%5D%20The%20People%E2%80%99s%20Josh%20-%20Brochure%20%281%29.pdf";

export const LEAFLET_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/nygw4e6u_Inclusion%20Leaflet%20%2810%29.pdf";

export const PHOTOS = {
  assembly:
    "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/vc6048xc_Untitled%20design%20%285%29.png",
  signs:
    "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/iqba5kwt_Untitled%20design%20%286%29.png",
  inclusion:
    "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/x0e47guw_Inclusion%20Leaflet.png",
  group:
    "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/8qv1cfyb_SKSSS%205.JPG",
  joshua:
    "https://customer-assets-jai6qajn.emergentagent.net/job_scholar-hub-473/artifacts/0hxjtkw4_Web_Photo_Editor.jpg",
};

export const FOUNDER = {
  name: "Joshua D Galstaun",
  nameSuffix: ", GMBPsS",
  post: "Director & Facilitator",
  aka: 'Known to students and staff as "JD Sir"',
  intro:
    "A former UK-based educator and psychologist with a decade of experience designing people-centred solutions.",
  roles: "Education Consultant. SEND* and Inclusion Expert. Counselling Psychologist.",
  rolesNote: "* Special Needs and Disabilities",
  quote:
    "I fell in love with psychology because I was fascinated by people's stories and by the ways in which the right support could help. A decade across education and psychology, in India and the UK, has only strengthened that belief. TPJ brings those worlds together: evidence and empathy, strategy and lived experience, challenge and potential.",
  experience: "Indian and International School Experience",
  credentials: [
    "BSc & MSc Applied Psychology (U.K.)",
    "Diploma in Counselling",
    "Child safeguarding certified",
    "Certified in Learning Disabilities Support",
    "School Policy & Strategy Enhancement",
    "Equality & diversity in school settings",
    "Indian and International School Experience",
  ],
  points: [
    "Delivered teacher training sessions to educators who teach different subjects to different age groups.",
    "Designed solution-focused and evidence-based interventions — including for students with special needs and dysregulated behaviour.",
    "Transformed school behaviour policies, social inclusion and risk-management approaches.",
    "Designed bespoke behavioural and crisis-intervention strategies and positive behaviour management approaches.",
    "Guided by insights from teachers and senior leaders with 500+ years of combined expertise.",
  ],
};

export const PILLARS = [
  {
    n: "01",
    title: "Teaching & Learning",
    tagline: "Stronger teaching. Deeper learning.",
    points: [
      "Evidence-informed teaching support",
      "Cognitive learning and thinking support",
      "Curriculum alignment & clarity",
      "Active learning strategies",
      "Retrieval practice",
    ],
    img: PHOTOS.group,
    highlight: "Whole School Enhancement of Teaching and Learning",
    cta: { label: "Strengthen Teaching & Learning", prefill: "Teaching & Learning" },
    flipTitle: "Delivering Workshops & Seminars on*",
    flipGroups: [
      {
        heading: "For Teachers",
        items: [
          "Understanding how students learn - Metacognition",
          "Building attention, engagement and participation",
          "Supporting different learning strengths",
          "Developing independent learners",
          "Preparing students for examinations",
        ],
      },
      {
        heading: "For Students",
        items: [
          "Effective study and revision strategies",
          "Managing procrastination and distractions",
          "Improving attention and concentration",
          "Goal-setting and personal responsibility",
          "Preparing for examinations with confidence",
        ],
      },
    ],
  },
  {
    n: "02",
    title: "Inclusive Education",
    tagline: "Every learner. Every classroom.",
    points: [
      "Supporting learners with SEND",
      "Inclusive classroom practices",
      "Adapting teaching & reasonable adjustments",
      "Teacher development & psychoeducation",
      "Whole-school inclusion culture",
    ],
    img: PHOTOS.signs,
    cta: { label: "Enhance Inclusion at Your School", prefill: "Inclusive Education" },
    flipTitle: "Delivering Workshops & Seminars on*",
    flipGroups: [
      {
        heading: "For Teachers",
        items: [
          "Understanding SEND & Neurodiversity",
          "Adaptive Teaching Strategies",
          "Understanding Behaviour Issues as Unmet Needs",
          "Facilitating Peer Support & Collaboration",
          "Workshops on Specific Special Education Needs e.g. ADHD, Autism etc",
        ],
      },
      {
        heading: "For Students",
        items: [
          "Challenging Bullying, Exclusion & Unkind Behaviour",
          "Building Empathy & Respecting Others",
          "Celebrating Individual Differences",
          "Challenging Stereotypes and Prejudice",
        ],
      },
    ],
  },
  {
    n: "03",
    title: "Student Wellbeing",
    tagline: "Wellbeing is where learning begins.",
    points: [
      "Promoting psychological safety",
      "Supporting emotional well-being",
      "Promoting academic engagement",
      "Building emotional resilience",
      "Positive school culture",
    ],
    img: PHOTOS.assembly,
    highlight: "Whole School Student Wellbeing Support",
    cta: { label: "Strengthen Student Wellbeing", prefill: "Student Wellbeing" },
    flipTitle: "Delivering Workshops & Seminars on*",
    flipList: [
      "Understanding and managing emotions",
      "Coping with academic stress and anxiety",
      "Developing confidence and self-belief",
      "Healthy friendships and personal boundaries",
      "Managing Anger & Conflict Constructively",
      "Digital wellbeing and social-media pressure",
      "Recognising when and how to seek help",
      "Life Skills Development",
    ],
  },
];

export const MISSION =
  "We are committed to providing outstanding educational support by building upon your existing strengths and encouraging continued development. TPJ will always remain available through consultation, staff training, student coaching and tailored services to support a school's journey towards excellence.";

export const OUTCOMES = [
  "Stronger student engagement & motivation",
  "Inclusive classrooms where every learner belongs",
  "Enhanced teaching & learning",
  "Improved student wellbeing",
  "Sustainable school growth",
  "Higher outcomes for all",
];

export const REAL_CHANGE = {
  label: "Real Change. Real Stories.",
  subject: "A 17-year-old with SEMH concerns and disruptive classroom behaviour.",
  before: [
    "Persistent disruption, frequent suspensions and disciplinary action",
    "Suspected substance-abuse involvement",
    "Disengaged from academics and classroom participation",
  ],
  after: [
    "Positive social relationships in class and on campus",
    "Improved behaviour and active participation",
    "Now in college, pursuing a career in the police force",
  ],
  note: "SEMH — Social, Emotional and Mental Health",
};

export const EVIDENCE = {
  stats: [
    { value: 95, label: "without formal inclusive-education training" },
    { value: 70, label: "teachers taught pupils believed to need additional support" },
  ],
};

export const PROCESS = [
  { n: "01", tag: "Day 1", title: "Initial Consultation", desc: "A brief 15–20 minute meeting with a designated school representative." },
  { n: "02", tag: "Day 1", title: "Classroom Observations", desc: "Observe teaching and learning across selected classes and year groups." },
  { n: "03", tag: "Day 1", title: "Wider School Environment", desc: "Break and lunch interactions, transitions between lessons and extracurriculars." },
  { n: "04", tag: "Day 1", title: "Staff Conversations", desc: "Speak with staff to answer questions and gather key information." },
  { n: "05", tag: "Day 2", title: "Teacher Training Workshop", desc: "Exclusive end-of-day CPD from JD Sir — data-informed, with Q&A." },
  { n: "06", tag: "1–3 days later", title: "Consultancy Report", desc: "Strengths, areas of development and practical, research-based recommendations." },
];

export const STATS = [
  { end: 7, suffix: "+", label: "Partner institutions" },
  { end: 400, suffix: "+", label: "Learners reached" },
  { end: 6, suffix: "yrs", label: "In education" },
  { end: 10, suffix: "yrs", label: "In psychology" },
];

export const TESTIMONIALS = [
  {
    text: "Your guidance has strengthened our inclusive approach and has been invaluable to our school's growth.",
    name: "Principal",
    role: "Senior Secondary School, India",
  },
  {
    text: "We will forever be grateful for your kindness and support for our son which definitely contributed towards his great exam results.",
    name: "Parents",
    role: "of a 12-year-old boy with autism",
  },
  {
    text: "You have created systems that have improved departmental performance, built clearly structured interventions, and reinvigorated students' passion for learning.",
    name: "Assistant Headteacher & SENDCO",
    role: "UK Secondary School",
  },
  {
    text: "You are incredibly professional, have had a significant positive impact and personally I enjoyed working with you.",
    name: "Headteacher",
    role: "UK Secondary School",
  },
];

export const FOUNDER_QUOTE = {
  text: "Every learner has the potential to thrive when teaching is evidence-informed and inclusive.",
  name: "Joshua Galstaun, GMBPsS",
  role: "Director & Facilitator",
};

export const TIME_SLOTS = [
  "10:00", "10:30", "11:00", "11:30", "12:00", "12:30",
  "14:00", "14:30", "15:00", "15:30", "16:00", "16:30",
];
